window.connectionGraph = (function() {

  var handleBarChart = function(data, divId) {
      "use strict";
      
      var barChartData = [{
          key: 'Cumulative Return',
          values: data
      }];

      nv.addGraph(function() {
          var barChart = nv.models.discreteBarChart()
              .x(function(d) { return d.label })
              .y(function(d) { return d.value })
              .showValues(true)
              .duration(250);
          
          barChart.yAxis.axisLabel("Leads Generated");
          barChart.xAxis.axisLabel('Month');
      
          d3.select(divId).append('svg').datum(barChartData).call(barChart);
          nv.utils.windowResize(barChart.update);
      
          return barChart;
      });
  }

  var handlePieAndDonutChart = function(data, divId) {
      "use strict";

      nv.addGraph(function() {
          var pieChart = nv.models.pieChart()
            .x(function(d) { return d.label })
            .y(function(d) { return d.value })
            .showLabels(true)
            .labelThreshold(.05);

          d3.select('#nv-pie-chart').append('svg')
              .datum(data)
              .transition().duration(350)
              .call(pieChart);

          nv.utils.windowResize(pieChart.update);

          return pieChart;
      });


      nv.addGraph(function() {
        var chart = nv.models.pieChart()
            .x(function(d) { return d.label })
            .y(function(d) { return d.value })
            .showLabels(true)
            .labelThreshold(.05)
            .labelType("percent")
            .donut(true) 
            .donutRatio(0.35);

          d3.select(divId).append('svg')
              .datum(data)
              .transition().duration(350)
              .call(chart);

          return chart;
      });
  };

  return {
    handleBarChart: handleBarChart,
    handlePieAndDonutChart: handlePieAndDonutChart
  }

})();